import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Img from "../Assets/icons/VELOXLogo.png";
import UserIcon from "../Assets/icons/User.svg";
import "../Styles/Dashboard.css";
import Axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import PanelType from './PanelType';
import panelVersions from "../Config/panelVersions.json";

const Dashboard = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isVelox, setIsVelox] = useState(false);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const iconRef = useRef(null);
  // const [canChangeVersion, setCanChangeVersion] = useState(false);
  const [isInternalUser, setIsInternalUser] = useState(false);

  const defaultVersion = panelVersions?.[0] || "2.0.F7";
  const [selectedVersion, setSelectedVersion] = useState(
    localStorage.getItem('panelVersion') || defaultVersion
  );
  const handleVersionChange = (e) => {
    const v = e.target.value;
    setSelectedVersion(v);
    localStorage.setItem('panelVersion', v);
    window.dispatchEvent(new CustomEvent('panelVersion:changed', { detail: v }));
  };

  // const allowVersionByEmail = (emailRaw) => {
  //   if (!emailRaw) return false;
  //   const email = String(emailRaw).trim().toLowerCase();
  //   // exact allowlist
  //   if (email === "kai@velox.ca" || email === "ateis-qc@ateis.ae") return true;
  //   // domain allowlist (handles subdomains too)
  //   return email.endsWith("velox.ca") || email.endsWith("ateis.ae");
  // };

  const isInternalUserByEmail = (emailRaw) => {
    if (!emailRaw) return false;
    const email = String(emailRaw).trim().toLowerCase();
    // exact allowlist
    if (email === "kai@velox.ca" || email === "ateis-qc@ateis.ae") return true;
    // domain allowlist (handles subdomains too)
    return email.endsWith("velox.ca") || email.endsWith("ateis.ae");
  };

  useEffect(() => {
    const email = localStorage.getItem('userEmail');
    // setCanChangeVersion(allowVersionByEmail(email));
    setIsInternalUser(isInternalUserByEmail(email));

    Axios.get('https://ipapi.co/json/').then((response) => {
      const ipAddress = response.data.ip;
      const ipLocation = {
        city: response.data.city,
        region: response.data.region,
        country: response.data.country_name,
        latitude: response.data.latitude,
        longitude: response.data.longitude
      };

      Axios.post(`${process.env.REACT_APP_BACKEND_URL}/store_ip_address`, {
        email: email,
        ipAddress: ipAddress,
        ipLocation: JSON.stringify(ipLocation)
      }).then((response) => {
        if (!response.data.success) {
          console.error("Failed to store IP information.");
        }
      }).catch((error) => {
        console.error("An error occurred while storing IP information.");
      });
    }).catch((error) => {
      console.error("Failed to fetch IP information.");
    });

    Axios.post(`${process.env.REACT_APP_BACKEND_URL}/get_user_role`, { email }).then((response) => {
      if (response.data.success) {
        setIsAdmin(!!response.data.is_admin);
        setIsVelox(!!response.data.is_velox);
      } else {
        toast.error("Failed to retrieve user role");
      }
    }).catch((error) => {
      toast.error("An error occurred while fetching user role.");
    });

    const loginSuccessMessage = localStorage.getItem('loginSuccessMessage');
    if (loginSuccessMessage) {
      toast.success(loginSuccessMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      localStorage.removeItem('loginSuccessMessage');
    }
  }, []);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target) && !iconRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleLogout = () => {
    localStorage.removeItem('@user');
    localStorage.removeItem('userEmail');
    navigate('/');
  };

  const createUser = () => {
    navigate('/create-user');
  };

  const showUsers = () => {
    navigate('/user-management');
  };

  const updatePassword = () => {
    navigate('/update_password');
  };

  const testYubiKey = () => {
    navigate('/test-yubikey');
  };

  const registerCustomerCode = () => {
    navigate('/register-customer-code');
  }

  return (
    <div className="dashboard">
      <div className='logo-VELOX'>
        <img src={Img} alt="VELOX Life Safety Inc." className="logo" />
        <div className="icon-with-version">
          <label htmlFor="panel-version" className="sr-only">Panel Version</label>
          <select
            id="panel-version"
            className="version-select"
            value={selectedVersion}
            onChange={handleVersionChange}
            aria-label="Select panel version"
            // disabled={!canChangeVersion}
          >
            {panelVersions.map(v => (
              <option key={v} value={v}>{v}</option>
            ))}
          </select>
        </div>
        <img
          src={UserIcon}
          alt="User Profile"
          className="user-pic"
          onClick={handleToggle}
          ref={iconRef}
        />
      </div>
      <hr className='login-breakline' />
      <PanelType panelVersion={selectedVersion} />
      {open && (
        <div className="sub-menu-wrap open-menu" ref={menuRef}>
          <div className="sub-menu">
            {isInternalUser && (
              <>
                <a href="#" className="sub-menu-link" onClick={testYubiKey}>
                  <p>Test YubiKey</p>
                </a>
                <a href="#" className="sub-menu-link" onClick={registerCustomerCode}>
                  <p>Create Customer Registration Code</p>
                </a>
              </>
            )}
            {isAdmin && (
              <>
                <a href="#" className="sub-menu-link" onClick={createUser}>
                  <p>Create User</p>
                </a>
                <a href="#" className="sub-menu-link" onClick={showUsers}>
                  <p>User Management</p>
                </a>
              </>
            )}
            <a href="#" className="sub-menu-link" onClick={updatePassword}>
              <p>Change Password</p>
            </a>
            <a href="#" className="sub-menu-link" onClick={handleLogout}>
              <p>Logout</p>
            </a>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default Dashboard;